import React from "react"
import PropTypes from "prop-types"
import MessageBox from "@/components/MessageBox"
import { withApi } from "@tencent/react-aio"
import _ from "lodash"
import Dialog from "@/components/Dialog"
import { enumMessages } from "@/utils/MessageUtils"

const reviewPass = "REVIEW_STATUS_PASSED"
const reviewReject = "REVIEW_STATUS_REJECTED"

class PaymentRejectModal extends React.Component {
  static propTypes = {
    orderInfo: PropTypes.object.isRequired,
    version: PropTypes.number.isRequired,
    onSubmit: PropTypes.func,
  }

  state = {}

  render() {
    const { orderInfo } = this.props
    const { reviewStatus, rejectReason, comments, error } = this.state
    const config = this.getMessages("ReviewStatus")

    // 拒绝理由
    const rejectReasonConfig = this.getMessagesForSelect("ReviewRejectReason")

    return (
      <Dialog className="spaui-dialog-confirm-normal" title="提示" {...this.props} onSubmit={this.onSubmit}>
        <div>确认驳回该到款订单</div>
        <div>（驳回后该订单状态将变为"到款驳回"）</div>
      </Dialog>
    )
  }

  getMessages = (key) => {
    return _.compact(
      _.map(enumMessages(key), (message) => {
        return {
          value: message.value,
          children: message.message,
        }
      })
    )
  }

  getMessagesForSelect = (key) => {
    return _.compact(
      _.map(enumMessages(key), (message) => {
        return {
          value: message.value,
          label: message.message,
        }
      })
    )
  }

  handleChange = (event, value) => {
    this.setState({
      reviewStatus: value,
      error: null,
    })
  }

  handleReasonChange = (event, value) => {
    this.setState({
      rejectReason: value,
    })
  }

  handleCommentsChange = (event) => {
    this.setState({
      comments: event.target.value,
    })
  }

  onSubmit = () => {
    const { webApi } = this.props
    const { orderInfo: order } = this.props
    const { reviewStatus, rejectReason, comments } = this.state

    const params = {
      orderId: order.orderId,
      leadId: order.leadId,
      createdTime: order.createdTime,
      reviewStatus: reviewStatus,
      rejectReason: rejectReason,
      comments: comments,
      version: this.props.version,
    }

    webApi
      .rejectOrderPayment()
      .ajaxJson({
        data: params,
      })
      .then(
        (resp) => {
          this.context.success("订单驳回成功！")
          this.props.onSubmit()
          this.props.refreshTable()
        },
        (error) => {
          this.context.error("订单驳回失败！", error.message)
          this.props.onSubmit()
        }
      )
  }
}

export default withApi(PaymentRejectModal)

PaymentRejectModal.contextType = MessageBox
